<!--
LOGIN BASE COMPONENT:
This component contains all login base functions.
Extend this component to change login template, customize functions and add styles
-->
<template>
  <div>
    <!--LOGIN-->
    <form v-if="mode === 'signin'" onsubmit="return false;">
      <div v-if="canLogin">
        <h3 style="text-align: center" v-text="_trans('')">Login</h3>
        <input v-model.number="userData.id" name="userid" type="number" placeholder="user id" />
        <input v-model="userData.name" autocomplete="user-name" name="username" type="text" placeholder="user name" />
        <input v-model="userData.password" autocomplete="current-password" name="password" type="password" placeholder="password" />

        <select v-model="backendSite">
          <option v-for="site in config.sites" :key="site" v-text="site" />
        </select>

        <a style="cursor: pointer" @click="switchMode('forgotpsw')" v-text="_trans('')">forgot password</a>
        <button @click="switchMode('registernew')" v-text="_trans('')">register new user</button>
        <button :disabled="!userData.id || !userData.name || !userData.password" @click="login" v-text="_trans('login')" />
      </div>

      <select v-model="user.shop" @change="setShop($event)">
        <!--<option disabled selected v-bind:value="undefined" v-text="_trans('')">select shop</option>-->
        <option v-for="shop in shops" :key="shop.cod" :value="shop" v-text="shop.cod + ' - ' + shop.des" />
      </select>

      <button v-if="!canLogin" type="button" @click="logout" v-text="_trans('logout')" />
    </form>

    <!--TODO: FORGOT PASSWORD-->
    <form v-else-if="mode === 'forgotpsw'">
      <input type="number" placeholder="user id" /> <input type="email" placeholder="user email" />

      <button @click="switchMode('signin')" v-text="_trans('back')" />
      <button v-text="_trans('continue')" />
    </form>

    <!--TODO: REGISTER NEW USER-->
    <form v-else-if="mode === 'registernew'">
      <input type="email" placeholder="user email" /> <input type="password" placeholder="password" />
      <input type="password" placeholder="repeat password" /> <textarea style="resize: none" placeholder="user info" />

      <button @click="switchMode('signin')" v-text="_trans('back')" />
      <button v-text="_trans('register')" />
    </form>
  </div>
</template>

<script>
    import {Auth} from "@3cad/nextcore";
    import {App} from "@3cad/nextcore";
    import {NextApiClient, LogwebAPI} from "@3cad/nextcore";

    export default {
        props: {
            showSites: {type: Boolean, default: true},
            showShops: {type: Boolean, default: true},
            showLogout: {type: Boolean, default: true}
        },
        data() {
            return {
                userData: {},
                forgotPassword: false,
                mode: "signin" /*,
            backend: Dau.g.backsite,
            sites: Dau.g.sites*/
            };
        },
        computed: {
            preferences() {
                return this.$store.getters["getPreferences"];
            },
            config() {
                return this.$store.getters["getConfig"];
            },
            /** Logged user shops computed list
             */
            shops() {
                return this.user.shops;
            },
            /** Change backend computed variable (redo guest login if backend is changed)
             */
            backendSite: {
                get: function () {
                    // return this.backend;);
                    return this.preferences.backsite;
                },
                set: function (newVal) {
                    this.preferences.backsite = newVal;
                    NextApiClient.backSite = this.preferences.backsite;
                    if (NextApiClient.UID) this.logout();
                }
            },
            sites() {
                return this.config.sites || [];
            },
            isGuestLogin() {
                return this.user && this.user.guest;
            },
            canLogin() {
                if (this.config.isguest) return this.isGuestLogin;
                else {
                    return !this.user || this.user.guest;
                }
            }
        },
        created() {
            if (process.env.NODE_ENV === "development") {

                // 3DLAB
                // this.userData.id = 752605;
                // this.userData.name = 'vasco@dau.it'
                // this.userData.password = 'p.vasco'

                // BULTHAUP
                // this.userData.id = 739146;
                // this.userData.name = 'andrea.gnoato@dau.it'
                // this.userData.password = 'p.andrea'

                // CALLIGARIS
                // this.userData.id = 731279;
                // this.userData.name = 'matteo.casagrande@dau.it'
                // this.userData.password = 'p.matteo'

                // CATTELAN
                // this.userData.id = 714746;
                // this.userData.name = 'guest1@cattelanitalia.com'
                // this.userData.password = 'p.cattelan'
                // this.userData.id = 714512;
                // this.userData.name = 'marzio@dau.it'
                // this.userData.password = 'p.cattelan'

                // DIOTTI
                // this.userData.id = 736488;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'

                // FALMEC
                // this.userData.id = 738929;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'

                // FAMI
                // --- Level 1 OK
                // this.userData.id = 736738;
                // this.userData.name = 'level1@dau.it'
                // this.userData.password = 'p.level1'
                // --- Level 2
                // this.userData.id = 736739;
                // this.userData.name = 'level2@dau.it'
                // this.userData.password = 'p.level2'
                // --- Level 3 OK
                // this.userData.id = 736740;
                // this.userData.name = 'level3@dau.it'
                // this.userData.password = 'p.level3'
                // --- Level 4
                // this.userData.id = 773123;
                // this.userData.name = 'level4@dau.it'
                // this.userData.password = 'p.level4'
                // --- Level 5
                // this.userData.id = 736742;
                // this.userData.name = 'level5@dau.it'
                // this.userData.password = 'p.level5'
                // --- Level 6
                // this.userData.id = 736743;
                // this.userData.name = 'level6@dau.it'
                // this.userData.password = 'p.level6'
                // -------------
                // this.userData.id = 736732; //Vasco (lev 6)
                // this.userData.name = 'vasco@dau.it'
                // this.userData.password = 'p.vasco'

                // FIRST
                // this.userData.id = 736663;
                // this.userData.name = 'scubeadmin'
                // this.userData.password = 'p.scube'

                // FRAEFEL
                // this.userData.id = 752639;
                // this.userData.name = 'ivan.vicevic@dau.it'
                // this.userData.password = 'p.ivan'
                // this.userData.id = 752643;
                // this.userData.name = 'matteo.maretto@dau.it'
                // this.userData.password = 'p.maretto'
                // this.userData.id = 752657;
                // this.userData.name = 'arturocorso73@gmail.com'
                // this.userData.password = 'p.arturo'
                // this.userData.id = 752636;
                // this.userData.name = 'arturo@dau.it'
                // this.userData.password = 'p.arturo'

                // GIORGETTI
                // this.userData.id = 750463;
                // this.userData.name = 'arturo@dau.it'
                // this.userData.password = 'p.arturo'
                // this.userData.id = 750462;
                // this.userData.name = 'stefano.villa@dau.it'
                // this.userData.password = 'p.stefano'

                // IONIASTONE
                // --- Level 2
                // this.userData.id = 750547;
                // this.userData.name = 'level2@dau.it'
                // this.userData.password = 'p.level2'
                // --- Level 5
                // this.userData.id = 750573;
                // this.userData.name = 'level5@dau.it'
                // this.userData.password = 'p.level5'
                // --- Level 5
                // this.userData.id = 750544;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'
                // --- Level 6
                // this.userData.id = 750542;
                // this.userData.name = 'vasco@dau.it'
                // this.userData.password = 'p.vasco'

                // IRONWOOD
                // this.userData.id = 700160;
                // this.userData.name = 'ironwood'
                // this.userData.password = 'p.ironwood'

                // LAMINAM
                // this.userData.id = 741357; // Liv 6
                // this.userData.name = 'vasco@dau.it'
                // this.userData.password = 'p.vasco'
                // this.userData.id = 741358; // Liv 3
                // this.userData.name = 'vasco@dau.it'
                // this.userData.password = 'p.vasco'
                // this.userData.id = 741359; // Liv 2
                // this.userData.name = 'vascob@compusoftgroup.com'
                // this.userData.password = 'p.vasco'

                // MBSTALAS
                // this.userData.id = 752244;
                // this.userData.name = 'vanessa@dau.it'
                // this.userData.password = 'p.vanessa'
                // this.userData.id = 752245;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'

                // MINIFABRIK
                // this.userData.id = 716457;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'

                // NATUZZI
                // this.userData.id = 729221;
                // this.userData.name = 'm.morga@serandp.com'
                // this.userData.password = 'p.natuzzi'

                // NEXT
                // this.userData.id = 700001;
                // this.userData.name = 'arturo@dau.it'
                // this.userData.password = 'p.arturo'
                // this.userData.id = 700014;
                // this.userData.name = 'vasco@dau.it'
                // this.userData.password = 'p.vasco'

                // PROGEO
                // --- Level 3
                // this.userData.id = 716822;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'
                // --- Level 6
                // this.userData.id = 713825;
                // this.userData.name = 'vasco@dau.it'
                // this.userData.password = 'p.vasco'
                // --- Level 2
                // this.userData.id = 716805;
                // this.userData.name = 'level2@rehateam.it'
                // this.userData.password = 'p.progeo'
                // --- Level 5
                // this.userData.id = 735315;
                // this.userData.name = 'level5@rehateam.it'
                // this.userData.password = 'p.progeo'

                // STIEMERT
                // this.userData.id = 752449;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'

                // TONINCASA
                // this.userData.id = 736382;
                // this.userData.name = 'bruno.grotto@dau.it'
                // this.userData.password = 'p.admin'
                // this.userData.id = 736383;
                // this.userData.name = 'roberto.galli@velve.it'
                // this.userData.password = 'p.roberto'

                // VDAGROUP
                // --- Level 2
                // this.userData.id = 738958;
                // this.userData.name = 'user@dau.it'
                // this.userData.password = 'p.user'
                // --- Level 5
                // this.userData.id = 738960;
                // this.userData.name = 'user5@dau.it'
                // this.userData.password = 'p.user'
                // --- Level 6
                // this.userData.id = 738959;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'
                // --- Level 6
                // this.userData.id = 738950;
                // this.userData.name = 'vasco@dau.it'
                // this.userData.password = 'p.vasco'

                // VITRUM
                // this.userData.id = 729106;
                // this.userData.name = 'seller2@dau.it';
                // this.userData.password = 'p.seller2';
                // this.userData.id = 729108;
                // this.userData.name = 'seller5@dau.it'
                // this.userData.password = 'p.seller5'
                // this.userData.id = 714503;
                // this.userData.name = 'vasco@dau.it';
                // this.userData.password = 'p.vasco';

                // VOITB2B
                // this.userData.id = 751585;
                // this.userData.name = 'marco.bottega@dau.it'
                // this.userData.password = 'p.marco'
                // this.userData.id = 736431;
                // this.userData.name = 'stefano.cortese@homag.com'
                // this.userData.password = 'p.stefano'
                // --- Level 1
                // this.userData.id = 736428;
                // this.userData.name = 'JuniorDesigner@voit.com'
                // this.userData.password = 'p.voit'
                // --- Level 2
                // this.userData.id = 751795;
                // this.userData.name = 'SeniorDesigner@voit.com'
                // this.userData.password = 'p.voit'
                // --- Level 3
                // this.userData.id = 751796;
                // this.userData.name = 'Agency@voit.com'
                // this.userData.password = 'p.voit'
                // --- Level 4
                // this.userData.id = 751797;
                // this.userData.name = 'CustomerCare@voit.com'
                // this.userData.password = 'p.voit'
                // --- Level 5
                // this.userData.id = 751798;
                // this.userData.name = 'OrderOffice@voit.com'
                // this.userData.password = 'p.voit'
                // --- Level 6
                // this.userData.id = 751799;
                // this.userData.name = 'Admin@voit.com'
                // this.userData.password = 'p.voit'

                // SGDEV
                // this.userData.id = 736642;
                // this.userData.name = "arturo@dau.it";
                // this.userData.password = "p.arturo";

                // TUBES
                // this.userData.id = 739099;
                // this.userData.name = "vasco@dau.it";
                // this.userData.password = "p.vasco";
                // this.userData.id = 739104;
                // this.userData.name = "marco.bottega@dau.it";
                // this.userData.password = "p.marco";
            }
        },
        mounted() {
        },
        beforeDestroy() {
        },
        methods: {
            setShop(e) {
                let shopCod = e.target.value;
                Auth.setShop(shopCod).then(newProfile => {
                    this.$store.commit("setProfile", newProfile);
                    this.shopChanged();
                });
            },
            setShopByObj(shop) {
                let shopCod = shop.cod;
                Auth.setShop(shopCod).then(newProfile => {
                    this.$store.commit("setProfile", newProfile);
                    this.shopChanged();
                });
            },
            shopChanged() {

            },
            switchMode(modeId) {
                this.mode = modeId;
            },
            /** Perform login
             */
            login() {
                Auth.login(this.userData.id, this.userData.name, this.userData.password)
                    .then(profile => {
                        this.$store.commit("setProfile", profile);
                        App.setLangFromUser(profile).then(() => {
                            App.afterLogin();
                            this.afterLogin();
                        });
                    })
                    .catch(err => {
                        // throw err;
                        this.$3cadInfo({
                            title: this._trans("Login failed"),
                            body: `${this._trans("Incorrect data, please check your credentials.")}`
                        });
                    });
            },
            afterLogin() {

            },
            /** Perform logout
             */
            logout() {
                Auth.logout()
                    .then(res => {
                        if (res.toLowerCase() === "ok") {
                            if (this.config.isguest)
                                Auth.guestLogin()
                                    .then(profile => {
                                        this.$store.commit("setProfile", profile);
                                        App.setLangFromUser(profile).then(() => {
                                            App.afterLogin();
                                        });
                                    })
                                    .catch(err => {
                                        throw err;
                                    });
                            else this.$store.commit("setProfile", null);
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        throw err;
                    });
            },
            sendPasswordReset() {
                LogwebAPI.lostPassword(
                    this.userData.id,
                    window.location.origin + "/#/resetpassword",
                    res => {
                        this.forgotPassword = false;
                    },
                    err => {
                        console.error(err);
                    }
                );
            }
            /** Close login session and get guest parameters
             * if guest is allowed from the backend
             */
            /*doend(){
                if (this.config.isguest) {
                    Dau.combase(this.backend, 'logweb', this.config.chainid?'GuestGetUIDChain':'GuestGetUID',
                        { Modo: 103,chainid:this.config.chainid || ''},
                        (d) => {
                            this.user.UID = d._UID;
                            Dau.getResponse(d);
                        });
                }
                else {
                    Dau.sessionend( d => {
                        this.user._UID = undefined;
                        Dau.getResponse(d);
                    });
                }
            }*/
        }
    };
</script>



// WEBPACK FOOTER //
// src/_eng/globals/_dlogin.vue